<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="full-middle"
      :visible.sync="modalVisible"
      :loading="loading"
      :confirmLoading="confirmLoading"
      not-footer-padding
      @confirm="confirm">
    <template #header>
      {{opType | optionText(OpEnum.typeOption)}}物流方式
    </template>
    <template #content>
      <div v-if="false">
        <gj-input v-model="labelWidth" />
        <gj-input v-model="label1Width" />
        <gj-input v-model="inputWidth" />
        <gj-input v-model="longInputWidth" />
      </div>
      <el-form
          ref="form"
          :model="form"
          :label-width="labelWidth">
        <gj-area-title>基本信息</gj-area-title>
        <el-row>
          <el-col :span="12">
            <el-form-item
                label="物流方式"
                prop="name"
                :rules="[
                  $gjRequired('请输入物流方式'),
                  customCheckName()
                ]">
              <gj-input
                  v-model="form.name"
                  :width="inputWidth"
                  :clearable="false"
                  placeholder="请输入物流方式">
              </gj-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="状态"
                prop="status"
                :label-width="label1Width"
                :rules="[$gjRequired('请选择物流方式')]">
              <gj-select
                  v-model="form.status"
                  :options="HeadLogistics.base.statusOption"
                  :width="inputWidth"
                  :clearable="false"
                  placeholder="请输入状态">
              </gj-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
                label="计费类型"
                prop="chargeType"
                :rules="[
                  $gjRequired('请输入计费类型'),
                ]">
              <gj-select
                  v-model="form.chargeType"
                  :options="HeadLogistics.base.chargeTypeOption"
                  :width="inputWidth"
                  :clearable="false"
                  placeholder="请输入计费类型">
              </gj-select>
            </el-form-item>
          </el-col>
          <el-col v-if="form.chargeType === 'charge'" :span="12">
            <el-form-item
                label="体积重折算系数"
                prop="volumeWeightCoefficient"
                :rules="[
                  $gjRequired('请输入体积重折算系数'),
                  $gjReRule(RE.pt, '请输入正整数')
                ]"
                :label-width="label1Width">
              <gj-input
                  v-model="form.volumeWeightCoefficient"
                  :width="inputWidth"
                  :clearable="false"
                  placeholder="5000/6000">
              </gj-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
            label="备注">
          <gj-input
              v-model="form.memo"
              placeholder="请输入备注"
              :width="longInputWidth">
          </gj-input>
        </el-form-item>
        <gj-area-title>时效信息</gj-area-title>
        <gj-button
            type="primary"
            style="margin-bottom: 6px;"
            @click="addItem"
        >添加</gj-button>
        <gj-table
            :index="false"
            :data="form.prescriptionList"
            :columns="columns"
            :show-overflow="false"
            :min-height="300"
            class="gj-table"
            :offset-height="54">
          <template v-slot:shippedCountryCode="{ index }">
            <el-form-item
                :prop="`prescriptionList.${index}.shippedCountryCode`"
                label-width="0px"
                class="gj-table-item"
                :rules="[$gjRequired('请选择国家')]">
              <gj-country-select
                  v-model="form.prescriptionList[index].shippedCountryCode"
                  includeCN
                  :clearable="false"
                  width="110px">
              </gj-country-select>
            </el-form-item>
          </template>
          <template v-slot:arrivalCountryCode="{ index }">
            <el-form-item
                :prop="`prescriptionList.${index}.arrivalCountryCode`"
                label-width="0px"
                class="gj-table-item"
                :rules="[$gjRequired('请选择国家')]">
              <gj-country-select
                  v-model="form.prescriptionList[index].arrivalCountryCode"
                  includeCN
                  :clearable="false"
                  width="110px">
              </gj-country-select>
            </el-form-item>
          </template>
          <template v-slot:prescription="{ index }">
            <el-form-item
                :prop="`prescriptionList.${index}.prescription`"
                label-width="0px"
                class="gj-table-item"
                :rules="[
                  $gjRequired('请输入时效'),
                  $gjReRule(RE.pt, '请输入正整数')
                ]">
              <gj-input
                  v-model="form.prescriptionList[index].prescription"
                  width="110px">
              </gj-input>
            </el-form-item>
          </template>
          <template v-slot:memo="{ index }">
            <el-form-item
                :prop="`prescriptionList.${index}.memo`"
                label-width="0px"
                class="gj-table-item">
              <gj-input
                  v-model="form.prescriptionList[index].memo"
                  width="500px">
              </gj-input>
            </el-form-item>
          </template>
          <template v-slot:op="{row,index}">
            <gj-button
                type="text"
                @click="deleteItem(row,index)"
            >删除</gj-button>
          </template>
        </gj-table>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, formRuleMixin, responseMixin, formDeleteItemMixin, opTypeMixin} from "../../../../../minxins";
  import {OpEnum} from "@/utils/options";
  import {HeadLogistics} from "../enum";
  import {
    addLogisticsTransport,
    checkTransportName,
    getLogisticsTransport,
    updateLogisticsTransport,verifyPrescriptionDelete
  } from "@/api/logistics";

  export default {
    name: "app-op-head-logistics-modal",
    mixins: [modalMixIn, formRuleMixin,
      responseMixin, formDeleteItemMixin, opTypeMixin],
    props: {
      data: {
        default: () => {}
      },
      opType: {
        required: true
      }
    },
    data() {
      return {
        loading: false,
        confirmLoading: false,
        form: {
          name: null,
          status: null,
          chargeType: null,
          volumeWeightCoefficient: null,
          prescriptionList: [],
          memo: null,
        },
        formItemsName: 'prescriptionList',
        columns: [
          {id: 'shippedCountryCode', header: '发货国家', required: true, field: 'slot:shippedCountryCode', width: '120px'},
          {id: 'arrivalCountryCode', header: '目的国家', required: true, field: 'slot:arrivalCountryCode', width: '120px'},
          {id: 'prescription', header: '时效(天)', field: 'slot:prescription', required: true, width: '120px'},
          {id: 'memo', header: '备注', field: 'slot:memo', minWidth: '200px'},
          {id: 'op', header: '操作', field: 'slot:op', width: '60px'},
        ],
        labelWidth: '110px',
        label1Width: '140px',
        inputWidth: '290px',
        longInputWidth: '810px',
        OpEnum: OpEnum,
        HeadLogistics: HeadLogistics
      }
    },
    created() {
      if (this.editOpType) {
        this.loading = true;
        getLogisticsTransport(this.data.id)
          .then(data => {
            Object.assign(this.form, data);
          })
          .complete(() => this.loading = false);
      }
    },
    methods: {
      deleteItem(row , index){
          if(row.id){
            verifyPrescriptionDelete(row.id).then(res => {
               if(res.data) {
                 this.form.prescriptionList.splice(index, 1);
               }
            })
          }else{
            this.form.prescriptionList.splice(index, 1);
          }
      },
      addItem() {
        this.form.prescriptionList.push({
          shippedCountryCode: null,
          arrivalCountryCode: null,
          prescription: null,
          memo: null,
          id: null,
          transportId: null
        });
      },
      customCheckName(trigger = ['blur']) {
        return {
          validator: (rule, value, callback) => {
            checkTransportName({
              name: value,
              id: this.form.id
            })
              .then(exist => {
                if (exist) {
                  callback(new Error('该物流方式已存在'));
                } else {
                  callback();
                }
              })
          },
          trigger,
        }
      },
      confirm() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this._.isEmpty(this.form.prescriptionList)) {
              this.$gjMessage.error('请添加时效信息');
            } else {
              this.confirmLoading = true;
              if (this.addOpType) {
                addLogisticsTransport(this.form)
                  .then((res) => {
                    this.$gjResponseHandle(res, () => {
                      this.$emit('created');
                    });
                  })
                  .complete(() => this.confirmLoading = false);
              } else if (this.editOpType) {
                updateLogisticsTransport(this.form)
                  .then((res) => {
                    this.$gjResponseHandle(res, () => {
                      this.$emit('updated');
                      this.$gjDestroy();
                    });
                  })
                  .complete(() => this.confirmLoading = false);
              }
            }
          }
        });
      },
      formValidate() {
        if (!this.$gjFormValidate()) {
          return false;
        }
        if (this._.isEmpty(this.form.prescriptionList)) {
          this.$gjMessage.error('请添加时效信息');
          return false;
        }
        return true;
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-col{
    .el-form-item{
      margin-bottom: 20px;
    }
  }
  /deep/ .gj-area-title{
    &:first-child{
      padding-top: 0;
    }
    padding-top: 4px;
  }
  /deep/ .gj-table{
    margin-top: 6px;
  }
  /deep/ .gj-table--default td:not(.vxe-footer--column){
    height: 56px !important;
  }
</style>


